export default "__VITE_ASSET__4e32be6a__"